import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import useAppMediaQuery from '@classity-edtech/ui-base/dist/hooks/useMediaQuery';
import { EmailVerification } from '@classity-edtech/ui-auth';
import Helmet from '../../components/Helmet';

export interface EmailConfirmationProps extends MuiBoxProps {}

export const EmailConfirmation = ({ className }: EmailConfirmationProps) => {
  const screens = useAppMediaQuery();

  const navigate = useNavigate();
  const { token } = useParams();

  const handleNavigation = (path: string) => {
    navigate(`/${path}${path === 'signin' ? `?isAccountActivated=true` : ''}`);
  };

  return (
    <>
      <Helmet />
      <EmailVerification token={token} navigate={handleNavigation} />
    </>
  );
};

EmailConfirmation.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

EmailConfirmation.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(EmailConfirmation)(
  ({ theme }) => `
  &.MuiBox-root {
    background-color: ${theme.palette.background.paper};
    min-height: 100vh;
  }
`,
);
